import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import p_nav_previous from "../../../Assets/Images/p_nav_previous.svg";
import ReactLoading from "react-loading";
import { toast } from "react-toastify";
import moment from "moment";
import NodeaxiosInstance from "../../../Services/nodeaxios";
import { MdCircle } from "react-icons/md";
import TicketCalender from "../../../Components/calender/TicketCalender";
import { IoIosArrowDown } from "react-icons/io";
import Kitchen_membership_card from "../../../Components/KitchenMembershipCard/Kitchen_membership_card";
import store_icon from "../../../Assets/Images/icons/store_icon.png"
import { RiErrorWarningLine } from "react-icons/ri";
import { FaRegCircle } from "react-icons/fa";
import { FaCircle } from "react-icons/fa";
import SelectShippingOffCanvas from "../../../Components/offCanvas/selectShippingOffCanvas";
import {   getVendorProfileDetails } from "../../../Services/api";
import { useDispatch, useSelector } from "react-redux";
import { setMembershipData } from "../../../redux/slices/kitchenMembershipSlice";
import { showToast } from "../../../Components/toastConfig/ToastConfig";
import CenterLoginNavigateModal from "../../../Components/modal/centerSmallModal";
import DatePicker from "react-datepicker";
import { addDays, startOfDay } from "date-fns";
import vegIcon from "../../../Assets/Images/vegpngoutput.png"
import nonvegIcon from "../../../Assets/Images/nomvegoutput.png"
import eggIcon from "../../../Assets/Images/eggpngoutput.png"
import { CgDanger } from "react-icons/cg";


// same unit ids as the mobile app
const PRODUCT_UNITS = { 1: "Grams", 2: "Kg", 3: "Ml", 4: "Liters", 5: "Pieces" };

export default function Kitchen_Membership_detail() {

    const [data, setData] = useState();
    const dispatch = useDispatch()
    const locations = useLocation();
    const state = useSelector((state) => state);
    const [userData, serUserData] = useState(state?.userAuth?.user);
    const { fromPage, booking_id } = locations.state || {};


    const { vendor_id, membership_ticket_id } = useParams();
    const navigate = useNavigate();

    const [showModal, setShowModal] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const handleLoginModalClose = () => setShowLoginModal(false);

    useEffect(() => {
        serUserData(state?.userAuth?.user);
    }, [state?.userAuth?.user]);

    const [showPasueRenewelModel, setShowPasueRenewelModel] = useState(false);

    const [pageLoaded, setPageLoaded] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [timeLeft, setTimeLeft] = useState(null);
    const [menuList, setMenuList] = useState([]);
    const [expiredStatus, setExpiredStatus] = useState(false)
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedDatePasueDate, setSelectedDatePasueDate] = useState('');

    const [selectedDatePasueFromDate, setSelectedDatePasueFromDate] = useState(null);
    const [selectedDatePasueEndDate, setSelectedDatePasueEndDate] = useState(null);


    const [showPauseModel, setShowPauseModel] = useState(false);
    const [selectPauseType, setSelectPauseType] = useState()
    const [vendorDate, setVendorDate] = useState()
    const [pasueConfirmModel, setPasueConfirmModel] = useState(false)
    const [ModelContentType, setModelContentType] = useState()
    const [showCancelConfirmModel, setShowCancelConfirmModel] = useState(false)
    const [openIndex, setOpenIndex] = useState(false);
    const [menuRawData, setMenuRawData] = useState()
    const latestMenuDate = useRef(null);

    const DEFAULT_Ticket_IMAGE_URL = "https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/FoodPlaceholderRect.png";


    useEffect(() => {
        fetch_ticket_deta()
    }, [])

    const fetch_ticket_deta = async () => {
        try {
            const headers = { Authorization: userData?.token };

            let url = fromPage == "mymembershiplist" ? 'single-membership-booking' : "fetch-single-membership"
            const response = await NodeaxiosInstance.get(`kitchen/${url}`, {
                params: {
                    vendor_id: vendor_id,
                    booking_id: booking_id,
                    membership_id: membership_ticket_id,
                },
                headers,
            });

            if (response.status == 200) {
                setPageLoaded(true);
                if (fromPage == "mymembershiplist") {
                    setData(response.data?.booking_detail);

                } else {
                    setData(response.data?.result);
                }

                let reqdata = { vendor_id: vendor_id }
                getVendorProfileDetails(reqdata).then((res) => {
                    setVendorDate(res?.data?.vendor_profile?.vendor_details)
                }).catch((error) => {


                });
                //   setErrorMessage(""); // clear any previous error
                // console.log("res.data.result----", response);
            } else {
                throw new Error(`Unexpected response status: ${response.status}`);
            }
        } catch (error) {
            console.error("Error fetching ticket details:", error);
            setPageLoaded(false);
            // setErrorMessage("Failed to load ticket details. Please try again later.");

            toast("Try Again Later", {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                className: "text-danger toast-style-1",
            });
        }
    };

    useEffect(() => {
        const checkIfExpired = () => {
            const now = moment();
            const bookBefore = data?.ticket_detail?.bookBefor;
            let deadline = moment(bookBefore);

            setExpiredStatus(now.isAfter(deadline) ? true : false);
        };

        checkIfExpired();

    }, [data]);


    useEffect(() => {
        if (!data?.ticket_detail?.bookBefore || data?.ticket_detail?.bookBefore == "0") return;
        const endTime = moment(data?.ticket_detail?.bookBefore);
        const now = moment();

        if (now.isAfter(endTime)) {
            setTimeLeft(0);
            return;
        }

        setTimeLeft(endTime.diff(now, "seconds"));

        const interval = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [data?.ticket_detail?.bookBefore]);

    const toggleDropdown = () => {
        setOpenIndex(!openIndex);
    };

    const getFilteredTicketDetails = async (formattedDate) => {
        try {
            const headers = { Authorization: userData?.token };

            // calendar sends a string ("DD-MM-YYYY" / "D MMMM YYYY"); normalise to a moment
            const dateMoment = moment.isMoment(formattedDate)
                ? formattedDate
                : moment(formattedDate, ["DD-MM-YYYY", "D MMMM YYYY"]);
            if (!dateMoment.isValid()) return;

            setSelectedDate(formattedDate)

            const apiDate = dateMoment.format("YYYY-MM-DD");
            latestMenuDate.current = apiDate;

            const res = await NodeaxiosInstance.get('/kitchen/fetch-membership-menu', {
                params: {
                    vendor_id: vendor_id,
                    date: apiDate,
                    membership_id: membership_ticket_id,
                },
                headers
            });

            // ignore responses for a date the user has already moved away from
            if (latestMenuDate.current !== apiDate) return;

            const menu = res.data.result || null;
            setMenuRawData(menu)
            setMenuList(menu?.products?.length > 0 ? menu.products : (menu?.combo?.products || []));

        } catch (err) {
            setMenuRawData(null)
            setMenuList([]);
        }
    };

    const pauseOptions = [{ id: 1, label: "Only Today" }, { id: 2, label: "This Week" }, { id: 3, label: "Custom Date" }];

    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",];

    const toggleOffCanvas = () => {
        setShowModal(!showModal)
    }

    const togglepausemodel = () => {
        if (data?.pause_status == 1) {
            resumeMembership()
        } else {
            setShowPauseModel(!showPauseModel)
            setIsModalOpen(!isModalOpen)
        }
    }

    const handelApiNavigate = async () => {
        if (userData?.user_type != "User") {
            setShowLoginModal(true);
            return;
        }
        try {
            let today = moment().toDate().toDateString();
            dispatch(
                setMembershipData({
                    "vendor_id": vendor_id,
                    "membership_id": membership_ticket_id,
                    "shipping_type": '',
                    "date": selectedDate ? selectedDate : today
                })
            );
            toggleOffCanvas()
        } catch (error) {

        }
    }

    const pauseMembership = async () => {
        try {
            const reqData = {
                booking_id: booking_id,
                pause_to_type: selectPauseType,
                pause_from: selectedDatePasueFromDate,
                pause_to: selectedDatePasueEndDate
            };
            const res = await NodeaxiosInstance.post("/kitchen/pause-membership", reqData);
            if (res.status == 200) {
                fetch_ticket_deta()
                togglepausemodel();
            }
        } catch (error) {
            console.error("Pause membership failed:", error);
            showToast("Unable to pause membership. Please try again.");
        }
    };

    const resumeMembership = async () => {
        try {
            const reqData = {
                booking_id: booking_id,
            };
            const res = await NodeaxiosInstance.post("/kitchen/resume-membership", reqData);
            if (res.status == 200) {
                fetch_ticket_deta()

            }
        } catch (error) {
            console.error("Pause membership failed:", error);
            showToast("Unable to pause membership. Please try again.");
        }
    };

    const cancelMembership = async () => {
        try {
            const reqData = {
                booking_id: booking_id
            };
            const res = await NodeaxiosInstance.post("/kitchen/cancel-membership", reqData);
            if (res.status == 200) {
                setShowCancelConfirmModel(false);
            }
        } catch (error) {
            console.error("Pause membership failed:", error);
            showToast("Unable to pause membership. Please try again.");
        }
    };




    const mealTimeMap = {
        1: { label: "Breakfast", time: "06:00 AM to 10:00 AM" },
        2: { label: "Morning Snacks", time: "05:00 PM to 11:00 PM" },
        3: { label: "Lunch", time: "12:00 PM to 04:00 PM" },
        4: { label: "Evening Snacks", time: "03:00 PM to 07:00 PM" },
        5: { label: "Dinner", time: "06:00 PM to 12:00 AM" },
        6: { label: "Midnight Food", time: "10:00 PM to 02:00 AM" }
    };


    const handleFromDateChange = (date) => {
        setSelectedDatePasueFromDate(date);
        setSelectedDatePasueEndDate(null);
    };

    const handleToDateChange = (date) => {
        setSelectedDatePasueEndDate(date);
    };

    const sevenYearsAgo = new Date();
    const today = new Date();
    sevenYearsAgo.setFullYear(today.getFullYear() - today);

    const unitTypes = [
        { id: 1, unitName: "Grams" },
        { id: 2, unitName: "Kg(s)" },
        { id: 3, unitName: "MI" },
        { id: 4, unitName: "Liters(s)" },
        { id: 5, unitName: "Pieces" },
    ];

    let termsArray = [];

    try {
        let raw = data?.terms_condition;

        if (typeof raw === "string") {
            raw = raw.replace(/\n/g, "");

            if (!raw.endsWith('"]')) {
                raw += '"]';
            }

            termsArray = JSON.parse(raw);
        } else if (Array.isArray(raw)) {
            termsArray = raw;
        }
    } catch (error) {
        console.error("Invalid JSON in terms_condition:", error);
        termsArray = [];
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white ">
                <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                    <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button"
                        onClick={() => navigate(-1)
                        } />
                    <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">Membership </div>
                </div>
                {/*   */}
            </div>

            {
                pageLoaded ?
                    <div className="kitchen-membership-details scroller-style-y">
                        <div className=" ">
                            {/* <Kitchen_membership_card Data={data} fromPage={'single'} />
                            <hr /> */}

                            <section className="section-spaces">
                                <div className="kitchen-membershipDetail-card group">
                                    <div className="kitchen-membership-image-wrapper">
                                        <img src={data?.ticket_image
                                            ? `https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/${data?.ticket_image}`
                                            : DEFAULT_Ticket_IMAGE_URL}
                                            alt="Chicken Biryani"
                                            className="kitchen-membership-image"
                                        />

                                        <div className="kitchen-membership-overlay" ></div>

                                        <div className="kitchen-membership-content">
                                            <h2 className="kitchen-membershipDetail-title">
                                                {data?.ticket_name}
                                            </h2>

                                        </div>

                                    </div>
                                </div>
                            </section>

                            <section className="section-spaces">
                                <h3 className="kitchen-membership-desc-title">Description</h3>

                                <p className="kitchen-membership-desc">{data?.about_ticket} </p>

                            </section>

                            <section className="section-spaces">
                                <div className="kitchen-membership-info-grid">

                                    {/* PRICE */}
                                    <div className="kitchen-membership-info-card">
                                        <div className="kitchen-membership-info-header">
                                            <span className="kitchen-membership-info-label"> Price</span>
                                        </div>

                                        <p className="kitchen-membership-info-value">
                                            <span className="rupeeIcon">₹</span>{data?.ticket_price}
                                        </p>
                                    </div>

                                    <div className="kitchen-membership-info-card">
                                        <div className="kitchen-membership-info-header">
                                            <span className="kitchen-membership-info-label">Membership Period</span>
                                        </div>

                                        <p className="kitchen-membership-info-value">
                                            {data?.validity_count_days} days
                                        </p>

                                        <span className="kitchen-membership-info-sub">
                                            from purchase date
                                        </span>
                                    </div>

                                    {/* Redeem Validity */}
                                    <div className="kitchen-membership-info-card">
                                        <div className="kitchen-membership-info-header">
                                            <span className="kitchen-membership-info-label">Redeem Validity</span>
                                        </div>
                                        <p className="kitchen-membership-info-value">
                                            {Number(data?.redeem_validity) > 0
                                                ? `${Number(data.redeem_validity)} ${Number(data.redeem_validity) === 1 ? "day" : "days"}`
                                                : "No limit"}
                                        </p>
                                    </div>

                                    {/* Carrier */}
                                    <div className="kitchen-membership-info-card">
                                        <div className="kitchen-membership-info-header">
                                            <span className="kitchen-membership-info-label">Carrier Option</span>
                                        </div>
                                        <p className="kitchen-membership-info-value">
                                            {data?.carrier_option == 1 ? "Available" : "Not available"}
                                        </p>
                                        {data?.carrier_option == 1 && (
                                            <span className="kitchen-membership-info-sub">
                                                ₹{data?.carrier_charges ?? 0} one time
                                            </span>
                                        )}
                                    </div>

                                    {/* Pause */}
                                    <div className="kitchen-membership-info-card">
                                        <div className="kitchen-membership-info-header">
                                            <span className="kitchen-membership-info-label">Pause</span>
                                        </div>
                                        <p className="kitchen-membership-info-value">
                                            {data?.membership_pause == 1 ? "Available" : "Not available"}
                                        </p>
                                    </div>

                                    {fromPage == "mymembershiplist" && data?.carrier_selected == 1 &&
                                        <div className="kitchen-membership-info-card full-width">
                                            <div className="kitchen-membership-info-header">
                                                <span className="kitchen-membership-info-label">Carrier Option</span>
                                            </div>
                                            <p className="kitchen-membership-info-value">
                                                Tiffin carrier - <span className="rupeeIcon">₹</span>{data?.carrier_booking_charge}
                                            </p>
                                        </div>
                                    }
                                    {data?.book_before_time &&
                                        <div className="kitchen-membership-info-card full-width">
                                            <div className="kitchen-membership-info-header">
                                                <span className="kitchen-membership-info-icon">⏱️</span>
                                                <span className="kitchen-membership-info-label">Confirm Before</span>
                                            </div>

                                            <p className="kitchen-membership-info-value">
                                                {data?.book_before_time} hrs
                                            </p>
                                        </div>}

                                </div>
                            </section>





                            <section className="section-spaces">
                                <h5 className="fs-16 ff-poppins-semiBold">Ticket Schedule</h5>
                                <TicketCalender handleFilteredTicketDate={(formattedDate) => getFilteredTicketDetails(formattedDate)} holidate={data} pageName={'memberShipDetails'} />
                            </section>

                            {
                                menuList?.length > 0 ? (
                                    <>
                                        <div className="menuDetailsBox">
                                            <div className="d-flex justify-content-between align-items-center">

                                                {/* LEFT SIDE */}
                                                <div className="d-flex">
                                                    <div className="mealTimeBox">
                                                        {menuRawData?.meal_type}
                                                    </div>

                                                    <div className="fs-12  fw-semibold ms-2">
                                                        <div className="text-dark">
                                                            {menuList[0]?.product_name}
                                                            {!openIndex && menuList?.length > 1 &&
                                                                <span className="secondary-text fs-11">
                                                                    (+{menuList?.length - 1}more)
                                                                </span>}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* ARROW */}
                                                <div
                                                    onClick={() => toggleDropdown()}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <IoIosArrowDown
                                                        style={{
                                                            transform: openIndex ? "rotate(180deg)" : "rotate(0deg)",
                                                            transition: "0.3s"
                                                        }}
                                                    />
                                                </div>

                                            </div>

                                            {/* DROPDOWN */}
                                            {openIndex && (
                                                <div className="dropdownContent mt-2">
                                                    {menuList?.map((item) => (
                                                        <div className="d-flex secondary-box p-2 mt-2 rounded-3" key={item?.kitchen_product_id}>
                                                            <div>
                                                                <img src={item?.product_image ? `https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/${item.product_image}` : DEFAULT_Ticket_IMAGE_URL}
                                                                    onError={(e) => (e.currentTarget.src = DEFAULT_Ticket_IMAGE_URL)}
                                                                    height="80px" width="80px" className="rounded-3" alt="" />
                                                            </div>
                                                            <div className="ms-3">
                                                                <p className="p-0 m-0 mt-1 fs-13 ff-poppins-medium">{item?.product_name}</p>
                                                                <div className="d-flex align-items-center">
                                                                    {item?.food_type && item?.food_type != 0 &&
                                                                        <img src={item?.food_type == "1" ? vegIcon : item?.food_type == "2" ? nonvegIcon : item?.food_type == "3" ? eggIcon : ""}
                                                                            height="13px" width="13px" className="me-1 foodTypeImg" alt="" />}
                                                                    <p className="p-0 m-0 fs-12 primary-text ff-poppins-medium">{item?.category_name}</p>
                                                                </div>
                                                                {item?.product_quantity_value != null && item?.product_quantity_value !== '' && (
                                                                    <p className="p-0 m-0 fs-11 primary-text ff-poppins-regular">
                                                                        Quantity: {item.product_quantity_value} {PRODUCT_UNITS[Number(item.product_quantity)] || ""}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </>
                                ) : (
                                    <span className="ff-poppins-medium fs-14 text-center d-flex justify-content-center">No menu added</span>
                                )
                            }


                            <div className="membershipAvailableDetails  mt-3">
                                <div>
                                    <h5 className="membershipAvailableTitle">Available Days</h5>
                                    <div className="membershipeAvailableTimelist">
                                        {
                                            days?.filter(d => !data?.regular_holidays?.includes(d))
                                                .map((d, index) => (
                                                    <span key={index} className="membershipeAvailableTime">
                                                        {d}
                                                    </span>
                                                ))
                                        }
                                    </div>
                                </div>
                                <div className="mt-3 mb-3">
                                    <h5 className="membershipAvailableTitle">Available Meal Hours</h5>

                                    <div className="membershipeAvailableMealTime">
                                        {
                                            mealTimeMap[data?.meal_time] && (
                                                <>
                                                    <span>{mealTimeMap[data.meal_time].label}</span>
                                                    <span>{mealTimeMap[data.meal_time].time}</span>
                                                </>
                                            )
                                        }

                                    </div>
                                </div>
                                {
                                    data?.additional_holidays_status == 1 ?
                                        <div>
                                            <h5 className="membershipAvailableTitle">Additional Holidays</h5>

                                            <div className="membershipeAvailableTimelist">
                                                {
                                                    data?.additional_holidays?.map((d, index) => {
                                                        const dateObj = new Date(d);
                                                        return (
                                                            <span key={index} className="membershipeAvailableTime">
                                                                {dateObj.getDate()}-{dateObj.getMonth() + 1}-{dateObj.getFullYear()}
                                                            </span>
                                                        );
                                                    })
                                                }

                                            </div>
                                        </div>
                                        : ""
                                }

                            </div>

                            {/* <div className="mb-4 mt-2">
                                <h6 className="p-0 m-0 fs-15 ff-poppins-medium">Ticket <span className="primary-text">Terms & Conditions </span>   </h6>
                                {
                                    data?.ticket_detail?.selected_terms && Array.isArray(JSON.parse(data?.ticket_detail?.selected_terms)) &&
                                    JSON.parse(data?.ticket_detail?.selected_terms).map((item, index) => (
                                        <div className="mt-2 mb-2 d-flex" key={index}>
                                            <div className="p-0 m-0 fs-8 mt-1 ff-poppins-semi-Bold">
                                                <MdCircle />
                                            </div>
                                            <p className="p-0 m-0 fs-12 ms-2 ff-poppins-regular">{item}</p>
                                        </div>
                                    ))
                                }
                            </div> */}

                            <section className="section-spaces">
                                <div className="kitchen-membership-terms-section">
                                    <div className="kitchen-membership-terms-header">
                                        <span className="kitchen-membership-terms-icon"><CgDanger /></span>
                                        <h3 className="kitchen-membership-terms-title ">Terms & Conditions</h3>
                                    </div>
                                    <ul className="kitchen-membership-terms-list">
                                        {termsArray?.map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>

                                </div>
                            </section>
                        </div>

                        {
                            !expiredStatus && fromPage != "mymembershiplist" ?
                                <div className="bg-light w-100" style={{ position: 'sticky', bottom: -8 }} >
                                    <button
                                        className="ff-poppins-medium primary-bg mt-3 mb-3 text-white w-100 sticky_bottom_btn_child"
                                        onClick={() => (userData?.user_type != "User" ? setShowLoginModal(true) : handelApiNavigate())}
                                    >
                                        Buy Now
                                    </button>
                                </div>
                                :
                                <div className="d-flex justify-content-between align-items-center ">
                                    <button className="medium-btn mb-3" onClick={() => setShowCancelConfirmModel(true)}>
                                        Cancel
                                    </button>
                                    <button className="medium-btn text-light primary-bg mb-3" onClick={() => togglepausemodel()}>
                                        {data?.pause_status == 1 ? 'Resume' : 'Pause'}
                                    </button>
                                </div>

                        }

                    </div > :

                    (
                        <div className=" ReactLoading">
                            <ReactLoading type={"spinningBubbles"} color={"#4E26A3"} />
                        </div>
                    )
            }
            {
                showModal &&
                <SelectShippingOffCanvas
                    isOpen={showModal}
                    toggleOffCanvas={toggleOffCanvas}
                    forCart={vendor_id}
                    data={{
                        ...vendorDate,
                        ...data,
                        ...data?.ticket_detail,
                        isMembership: true,
                        dinein_status: '0',
                        dinein_product_status: '0',
                        instore_status:
                            data?.ticket_detail?.delivery_type == 1 ||
                            data?.ticket_detail?.delivery_type == 3 ||
                            data?.delivery_type == 1 ||
                            data?.delivery_type == 3 ||
                            vendorDate?.instore_product_status == '1' ||
                            vendorDate?.instore_status == '1' ||
                            (!data?.ticket_detail?.delivery_type && !data?.delivery_type)
                                ? '1'
                                : '0',
                        doorstep_status:
                            data?.ticket_detail?.delivery_type == 2 ||
                            data?.ticket_detail?.delivery_type == 3 ||
                            data?.delivery_type == 2 ||
                            data?.delivery_type == 3 ||
                            vendorDate?.product_delivery_status == '1' ||
                            vendorDate?.doorstep_status == '1' ||
                            (!data?.ticket_detail?.delivery_type && !data?.delivery_type)
                                ? '1'
                                : '0',
                    }}
                />
            }

            {
                showPauseModel &&
                <div className="offcanvas kitchenMembershipPauseModel show" >
                    <div className="bg-light">
                        <div>
                            <div className="primary-gradient-box text-center rounded-3">
                                <span className="primary-text fs-20">  <RiErrorWarningLine /></span>


                                <h5 className="primary-text ff-poppins-semiBold p-0 m-0 fs-15" >Pause the Membership Ticket</h5>
                                <p className="primary-text ff-poppins-regular p-0 m-0 fs-12">Are you sure you want to pause the ticket?<br />
                                    After the pause duration, the membership will automatically resume.</p>
                            </div>

                            <div className="ms-3 mt-3">
                                {pauseOptions.map(option => (
                                    <div key={option.id}
                                        className="d-flex align-items-center mb-2 cursor-pointer"
                                        onClick={() => setSelectPauseType(option.id)}
                                    >
                                        <span>
                                            {selectPauseType === option.id ?
                                                <FaCircle size={15} color="#4E26A3" />
                                                :
                                                <FaRegCircle size={15} color="#4E26A3" />}

                                        </span>
                                        <div className="ms-2 mt-1">
                                            <h6 className="fs-14 p-0 m-0 ff-poppins-medium">
                                                {option.label}
                                            </h6>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {
                                selectPauseType == 3 &&

                                <div className="ms-3 d-flex justify-content-between pasueMembershipDatepicker">

                                    {/* Pause From */}
                                    <div>
                                        <span className="fs-12 ff-poppins-medium secondary-text-1">
                                            Pause From
                                        </span> <br></br>
                                        <div>
                                            <DatePicker
                                                className="date-box"
                                                selected={selectedDatePasueFromDate}
                                                onChange={handleFromDateChange}
                                                dateFormat="dd-MM-yyyy"
                                                showYearDropdown
                                                scrollableYearDropdown
                                                yearDropdownItemNumber={100}
                                                portalId="custom-calendar-portal"
                                                minDate={startOfDay(new Date())} // ❌ no past dates
                                            />
                                        </div>
                                    </div>

                                    {/* Pause To */}
                                    <div>
                                        <span className="fs-12 ff-poppins-medium secondary-text-1">
                                            Pause To
                                        </span><br></br>
                                        <div>

                                            <DatePicker
                                                className="date-box"
                                                selected={selectedDatePasueEndDate}
                                                onChange={handleToDateChange}
                                                dateFormat="dd-MM-yyyy"
                                                showYearDropdown
                                                scrollableYearDropdown
                                                yearDropdownItemNumber={100}
                                                portalId="custom-calendar-portal"
                                                disabled={!selectedDatePasueFromDate} // disabled until From selected
                                                minDate={
                                                    selectedDatePasueFromDate
                                                        ? addDays(selectedDatePasueFromDate, 7) // ✅ minimum 1 week gap
                                                        : null
                                                }
                                            />
                                        </div>

                                    </div>

                                </div>
                            }
                            <div className="mt-1">
                                <button className='primary-bottom-Lg-Btn' onClick={() => pauseMembership()}>
                                    Confirm
                                </button>
                            </div>
                        </div>
                        {/* {cancelConfirmModal && <div className="modal-backdrop fade show"></div>} */}
                    </div>
                </div>
            }
            {showCancelConfirmModel && (
                <>
                    <div className="modal-backdrop fade show"></div>

                    <div className="offcanvas kitchenMembershipPauseModel show" style={{ minHeight: '20vh' }} >
                        <div className="bg-light">
                            <div>
                                <div className="danger-gradient-box text-center rounded-3">
                                    <span className="text-danger fs-20">  <RiErrorWarningLine /></span>


                                    <h5 className="text-dark ff-poppins-semiBold p-0 m-0 fs-15" >Cancel the Membership Ticket</h5>
                                    <p className="text-dark ff-poppins-regular p-0 m-0 fs-12">Are you sure you want to cancel the ticket? The membership charge will not be refundable</p>
                                </div>



                                <div className="mt-3">
                                    <button className='danger-bottom-Lg-Btn' onClick={() => cancelMembership()}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                            {/* {cancelConfirmModal && <div className="modal-backdrop fade show"></div>} */}
                        </div>
                    </div>
                </>
            )}


            {isModalOpen && <div className="modal-backdrop fade show"></div>}

            <CenterLoginNavigateModal
                showModal={showLoginModal}
                pathname={locations.pathname}
                onclose={handleLoginModalClose}
            />


        </>
    )
}














